import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

export function AdminLoader({ className }: Readonly<{ className?: string }>) {
  return (
    <div
      className={cn(
        'fixed inset-0 z-[1023] flex items-center justify-center bg-background/70 backdrop-blur-[2px]',
        className,
      )}
    >
      <Spinner className="size-8 text-primary" />
    </div>
  );
}
